'use strict';

module.exports = function () {
    $(window).on('load', function () {
        let listImages = JSON.parse($('#urlImages').val()).map(image => image.url);
        if (listImages.length > 0) {
            $('#mySpriteSpin').spritespin({
                source: listImages,
                width: 650,
                height: 520,
                sense: -1,
                responsive: true,
                animate: false,
                plugins: [
                    '360',
                    'drag'
                ]
            });
        }
    });
};
